import PropTypes from 'prop-types';
import { useTheme } from '@mui/material';
import { DatePickerBase } from '@baseComponents/DateTimePicker';

const VIEWS = ['year']; // only year view

const maxDate = new Date(); // allow selecting up to the current year

const propTypes = {
    name: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string
};

const defaultProps = {
    name: 'timesheets-year-picker',
    views: VIEWS,
    openTo: 'year',
    maxDate,
    inputFormat: 'YYYY' // show only year
};

const TimesheetsYearPicker = (props) => {
    const { spacing } = useTheme();

    return (
        <DatePickerBase
            {...props}
            styles={{ input: { height: spacing(4.5) } }}
        />
    );
};

TimesheetsYearPicker.propTypes = propTypes;
TimesheetsYearPicker.defaultProps = defaultProps;

export { TimesheetsYearPicker as default, TimesheetsYearPicker };
